export const validationRules = {
  email: (value) => {
    if (!value) return "Email is required";
    if (value.length < 5) return "Email must be at least 5 characters long";
    if (value.length > 50) return "Email must be less than 50 characters";
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(value)) return "Please enter a valid email address";
    return "";
  },

  phone: (value) => {
    if (!value) return "Phone number is required";
    const regex = /^[6-9]\d{9}$/;
    if (!regex.test(value))
      return "Phone number must be a valid 10-digit Indian number";
    return "";
  },

  password: (value) => {
    if (!value) return "Password is required";
    if (value.length < 8) return "Password must be at least 8 characters";
    const regex = /^(?=.*[A-Z])(?=.*\d).+$/;
    if (!regex.test(value))
      return "Password must include an uppercase letter and a number";
    return "";
  },

  postCode: (value) => {
    if (!value) return "PIN code is required";
    return "";
  },

  postcode: (value) => {
    if (!value) return "PIN code is required";
    return "";
  },

  name: (value) => {
    if (!value) return "Name is required";
    if (value.length < 2) return "Name must be at least 2 characters";
    if (value.length > 30) return "Name must be less than 30 characters";
    return "";
  },

  address: (value) => {
    if (!value) return "Address is required";
    if (value.length < 2) return "Address must be at least 2 characters";
    if (value.length > 50) return "Address must be less than 30 characters";
    return "";
  },

  default: (value, fieldName = "This field") => {
    if (!value) return `${fieldName} is required`;
    if (value.length < 2) return `${fieldName} must be at least 2 characters`;
    if (value.length > 30)
      return `${fieldName} must be less than 30 characters`;
    return "";
  },
};
